import DiscountSchemesShow from "./discountSchemesShow";
import DiscountSchemesList from "./discountSchemesList";
import DiscountSchemesEdit from "./discountSchemesEdit";
import DiscountSchemesCreate from './discountSchemesCreate';

export default {
  show: DiscountSchemesShow,
  list: DiscountSchemesList,
  edit: DiscountSchemesEdit,
  create: DiscountSchemesCreate,
};
